import React from 'react';

import { Flex, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

export type Props = {
  holidayConfirmation?: {
    description: string;
    isGreen: boolean;
  };
};

const HolidayConfirmation: React.FC<Props> = ({ holidayConfirmation }) => {
  const { background } = useTheme();
  if (!holidayConfirmation) {
    return null;
  }

  const { description, isGreen } = holidayConfirmation;

  return (
    <Flex
      data-testid="holiday-confirmation"
      backgroundColor={isGreen ? background.success : background.info}
      borderRadius="24px"
      px="2x"
      py="1x"
    >
      <Text size="100">{description}</Text>
    </Flex>
  );
};

export default HolidayConfirmation;
